import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  makeStyles,
  TextField
} from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { green } from '@material-ui/core/colors';
import { Formik } from 'formik';
import CustomDialog from 'src/app/components/CustomDialog';
import { STATUS_API } from 'src/app/constant/config';
import { getServicePackage, postExtendDevice } from 'src/features/deviceSlice';

const ExtendDevice = ({ open, onClose, device }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const statusTransfer = useSelector(state => state.agencySlice.statusTransfer);

  const listPackage = useSelector(state => state.deviceSlice.listPackage);

  const serviceOption = (listPackage || [])
    ?.filter(item => {
      const pkgName = item?.name || '';
      const isActivation = item?.type ? item.type === 'KICH_HOAT' : /kích hoạt|active|kh/i.test(pkgName);
      return !isActivation;
    })
    ?.map(item => {
      return {
        id: Number(item.id),
        cost: item.cost,
        name: item.name
      };
    });

  useEffect(() => {
    if (device.id) {
      dispatch(
        getServicePackage({
          device_type_id: device?.deviceType?.id,
          version: device?.hardware_version
        })
      );
    }
  }, [device]);

  const handleSubmit = data => {
    if (data.service_package_id && device.id) {
      dispatch(
        postExtendDevice({
          id: Number(device.id),
          data: {service_package_id: data.service_package_id}
        })
      );
    }
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <CustomDialog
      title="Chọn gói dịch vụ"
      open={open}
      onClose={handleClose}
      sizeSmall={true}
    >
      <div>
        <Formik
          initialValues={{ service_package_id: '' }}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            service_package_id: Yup.number()
              .required('Gói dịch vụ không được để trống')
          })}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                  <InputLabel>
                    Chọn gói dịch vụ <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    className="input-no-fieldset"
                    size="small"
                    fullWidth
                    select
                    error={Boolean(touched.service_package_id && errors.service_package_id)}
                    helperText={touched.service_package_id && errors.service_package_id}
                    margin="normal"
                    name="service_package_id"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    SelectProps={{
                      native: true
                    }}
                    value={Number(values.service_package_id)}
                    variant="outlined"
                  >
                    <option>Chọn gói dịch vụ</option>
                    {serviceOption &&
                      serviceOption.map(option => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                  </TextField>
                </Grid>
              </Grid>
              <Box my={3}>
                <Box
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '15px',
                    '& .left-button': {
                      display: 'flex'
                    }
                  }}
                >
                  <Button
                    style={{
                      marginRight: '10px',
                      textTranform: 'none !important'
                    }}
                    onClick={() => onClose()}
                    className="btn-main btn-plain mx-3"
                    color="primary"
                    size="large"
                    variant="contained"
                  >
                    Thoát
                  </Button>
                  <Button
                    style={{
                      marginRight: '10px',
                      textTranform: 'none !important'
                    }}
                    className="btn-main mx-3"
                    color="primary"
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Gia hạn
                  </Button>
                  {statusTransfer === STATUS_API.PENDING && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Box>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </CustomDialog>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',

    '& .left-button': {
      display: 'flex'
    }
  },
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}));

export default React.memo(ExtendDevice);
